import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchRepresentantAdministration } from 'utils/fetchers';
import { patchRepresentant } from 'store/administration/administrationActions';
import AdministrationRepresentant from './AdministrationRepresentant';

class AdministrationRepresentantContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            representant: null
        };
    }

    async componentDidMount() {
        const { code } = this.props;

        var representant = await this.props.fetchRepresentantAdministration(code);

        this.setState({representant : representant});
    }
           
    handleChange = (event) => {

        let newRepresentant = this.state.representant;
        
        if (event.target.name === 'pctJokerFraisRetour') {
            newRepresentant.pctJokerFraisRetour = event.target.value;
        }
               
        this.setState({ ...this.state, representant: newRepresentant });
    };

    handleClickSave = async () => {
        await this.props.patchRepresentant(this.state.representant);
    };

    render() {
        const { representant } = this.state;

        return (
            <AdministrationRepresentant
                representant={representant}
                isPatching={false}
                onChange={this.handleChange}
                onClickSave={this.handleClickSave}
            />);
    }
}

AdministrationRepresentantContainer.propTypes = {
    code: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => ({
    fetchRepresentantAdministration: (representantCode) => dispatch(fetchRepresentantAdministration(representantCode)),
    patchRepresentant: (representant) => dispatch(patchRepresentant(representant))
});

export default connect(null, mapDispatchToProps)(AdministrationRepresentantContainer);